<template>
    <div class="nc-messenger">
        <v-preloader v-if="isLoading" class="preloader_type_button" size="small" />
        <template v-else>
            <div v-if="!messages.length" class="nc-messenger__empty">Нет сообщений</div>
            <div v-else ref="list" class="nc-messenger__list">
                <div v-for="msg in messages" :key="msg.id" class="nc-messenger__row">
                    <new-chat-message-event v-if="msg.type === 'event'" :message="msg" />
                    <new-chat-message-media
                        v-else-if="msg.type === 'media'"
                        :message="msg"
                        @open="viewerAttachment = $event"
                        @file-downloaded="_onFileDownloaded"
                    />
                    <new-chat-message-text v-else-if="msg.type === 'text'" :message="msg" />
                </div>
            </div>
        </template>
        <new-chat-attachment-viewer
            :attachment="viewerAttachment"
            @close="viewerAttachment = null"
        />
    </div>
</template>

<script>
import api from '@api'
import vPreloader from '../../global/Preloader.vue'
import NewChatMessageEvent from './messages/NewChatMessageEvent.vue'
import NewChatMessageText from './messages/NewChatMessageText.vue'
import NewChatMessageMedia from './messages/NewChatMessageMedia.vue'
import NewChatAttachmentViewer from './NewChatAttachmentViewer.vue'

export default {
    name: 'NewChatHistoryMessenger',
    components: {
        vPreloader,
        NewChatMessageEvent,
        NewChatMessageText,
        NewChatMessageMedia,
        NewChatAttachmentViewer,
    },
    props: {
        customerId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            messages:        [],
            isLoading:       false,
            isLoadingMore:   false,
            currentPage:     1,
            hasMore:         true,
            viewerAttachment: null,
        }
    },
    created() {
        this._scrollHandler  = () => this._onScroll()
        this._prepending     = false
        this._ignoringScroll = false
        this._loadingMore    = false
    },
    mounted() {
        this.fetchMessages()
    },
    beforeDestroy() {
        const el = this.$refs.list
        if (el) el.removeEventListener('scroll', this._scrollHandler)
    },
    watch: {
        isLoading(val) {
            if (!val) {
                this.$nextTick(() => {
                    this._attachScrollListener()
                    this._scrollToBottom()
                })
            }
        },
    },
    methods: {
        fetchMessages() {
            this.isLoading   = true
            this.currentPage = 1
            this.hasMore     = true

            api.newChat.getHistoryMessages(this.customerId, 1)
                .then(response => {
                    const msgs  = response.messages || []
                    const limit = (response.pagination && response.pagination.limit) || 100
                    this.messages = msgs
                    if (msgs.length < limit) this.hasMore = false
                })
                .catch(err => {
                    console.error('[NewChat] history messages error:', err)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        _attachScrollListener() {
            const el = this.$refs.list
            if (!el || el._hasScrollListener) return
            el.addEventListener('scroll', this._scrollHandler)
            el._hasScrollListener = true
        },

        _scrollToBottom() {
            const el = this.$refs.list
            if (!el) return
            this._ignoringScroll = true
            el.scrollTop = el.scrollHeight
            this.$nextTick(() => { this._ignoringScroll = false })
        },

        _onScroll() {
            if (this._ignoringScroll || this._loadingMore || !this.hasMore) return
            const el = this.$refs.list
            if (!el || el.scrollTop >= 80) return
            this._loadMoreMessages()
        },

        _onFileDownloaded({ id, message }) {
            const idx = this.messages.findIndex(m => m.id === id)
            if (idx !== -1) {
                this.$set(this.messages, idx, { ...this.messages[idx], message })
            }
        },

        _loadMoreMessages() {
            const el = this.$refs.list
            if (!el) return
            const nextPage         = this.currentPage + 1
            const prevScrollHeight = el.scrollHeight

            this._loadingMore  = true
            this.isLoadingMore = true

            api.newChat.getHistoryMessages(this.customerId, nextPage)
                .then(response => {
                    const msgs  = response.messages || []
                    const limit = (response.pagination && response.pagination.limit) || 100
                    const existingIds = new Set(this.messages.map(m => m.id))
                    const newMsgs = msgs.filter(m => !existingIds.has(m.id))

                    if (newMsgs.length === 0) {
                        this.hasMore = false
                        return
                    }

                    this._prepending  = true
                    this._loadingMore = false
                    this.isLoadingMore = false
                    this.messages = [...newMsgs, ...this.messages]
                    this.currentPage = nextPage
                    if (msgs.length < limit) this.hasMore = false

                    this.$nextTick(() => {
                        if (!el.isConnected) return
                        this._ignoringScroll = true
                        el.scrollTop = el.scrollHeight - prevScrollHeight
                        this._prepending = false
                        this.$nextTick(() => { this._ignoringScroll = false })
                    })
                })
                .catch(err => {
                    console.error('[NewChat] history loadMore error:', err)
                })
                .finally(() => {
                    this._loadingMore  = false
                    this.isLoadingMore = false
                })
        },
    },
}
</script>